import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-border',
  templateUrl: './ui-border.component.html',
  styleUrls: ['./ui-border.component.css']
})
export class UiBorderComponent {
  /**
   * Header button list show
   */
  Settingicon = true;
  Menuoption = 'center'
}
